<template>
  <transition name="modal">
    <div :id="id" class="modal" v-show="show" :class="type">
      <vue-audio :file="3" ref="closeModal" :redirect="redirect"></vue-audio>
      <template v-if="type === 'alert'">
        <button class="modal__button--close" @click="closeModal">×</button>
      </template>
      <div class="modal__table">
        <div class="modal__cell">
          <div class="modal__box">
            <div class="modal__table">
              <div class="modal__cell">
                <div v-html="message[id]"></div>
                <template v-if="type === 'confirm'">
                  <p class="modal__row">
                    <button class="modal__button" @click="goTo">YES</button>
                    <button class="modal__button" @click="closeModal">NO</button>
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import { store } from '../store/store'
  import Audio from './Audio'
  export default {
    name: 'Modal',
    data () {
      return {
        message: {
          specialCard: 'ゲノムカード１枚をCRISPR-CASカードに<br>変えてもう一度ゲームをやりますか？',
          specialCardInfo: '<p>CRISPR-CASカードとは？</p><p>CRISPR-CAS／クリスパーキャスカードは各要素の値がマックスなスペシャルカードです。</p><p>このゲームでは第一染色体カード２枚のどちらかをCRISPR-CASカードに変更することができます。</p><p><a href="http://horikawad.hatenadiary.com/entry/2015/10/05/123910" target="_blank">> <span>CRISPR-CASについてもっと詳しく知る</span></a></p>',
          howTo: '<p class="how-to__title">ユニコーン運動会　ゲームのやり方</p><p class="how-to__text">このゲームはゲノムの世界についての理解を、ゲームを通して深めてもらうことを目的としています。<!--<br>--------------------------------------------------------------------<br>--><span class="how-to__border"></span>ここはユニコーンの住む魔法のゲノムワールド。ゲノムカードを使ってユニコーンをよびだして運動会で対決しよう！</p><p class="how-to__text">カードの組み合わせで様々なスペックのユニコーンをよびだせるよ。<br>勝てない時は魔法のカード<a style="color: red" href="http://horikawad.hatenadiary.com/entry/2015/10/05/123910" target="_blank">“CRISPR-CAS／クリスパーキャス”カード</a>を使ってみよう！</p><p class="how-to__text">君のユニコーンは勝てるかな？</p>',
          race: '同じゲノムカードでもう一度やる',
          card: '最初からやる',
          close: '終わる',
          top: 'ゲームを中断して最初の画面に戻りますが良いですか。'
        },
        redirect: ''
      }
    },
    props: ['show', 'id', 'type'],
    components: {
      'vue-audio': Audio
    },
    computed: {
    },
    methods: {
      closeModal () {
        this.$refs.closeModal.play()
        this.$emit('update:show', false)
      },
      goTo () {
        this.$refs.closeModal.play()
        switch (this.id) {
          case 'top':
//            setTimeout(() => { location.reload() }, 150)
            store.dispatch('setResetStatus', !store.state.resetStatus)
            setTimeout(() => {
              store.dispatch('resetGame')
              store.dispatch('setCurrentScreen', 'welcome')
              this.$emit('update:show', false)
            }, 150)
            break
          case 'close':
            setTimeout(() => { parent.$.fancybox.close() }, 150)
            break
          default:
            this.redirect = this.id
            store.dispatch('setReplay', true)
            // store.dispatch('setCurrentScreen', this.id)
            if (this.id === 'card') {
              store.dispatch('resetGame')
//              setTimeout(() => {
//                location.reload()
//                store.dispatch('setCurrentScreen', 'card')
//              }, 150)
            }
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Modal.vue?27d6b052